// extracted by mini-css-extract-plugin
export var orderSummary = "_uo-0";
export var showMoreLessButton = "_uo-1";